import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import SearchFieldsContext from '../context/context'
import { sortArray } from '../../../PropertyList/Utility/PropertyListUtility'

const LocationFilters = () => {
  // const [fieldTypes] = React.useState(props.fieldTypes)
  const { searchFields, setSearchFields, searchResult } = useContext(SearchFieldsContext)

  const listLocationTypes = searchFields.locationFields.filter(x => x.locationValue === 'all')

  useEffect(() => {
    searchFields.locationFields = [...searchFields.locationFields.slice(0, 4)]
    searchFields.locationFields.forEach((item) => {
      item.show = false
      item.arrow = 'rotate(180)'
    })
    if (!searchFields.isLocationLoaded || searchResult.property.length) {
      searchFields.isLocationLoaded = true
      formatLocationFilter(searchResult.property)
      // else{
      //   fetchLocationData()
      // }
    }
  }, [])

  // useEffect(() => {

  // }, [searchResult])


  const getUniqueValues = (collection, prop) => {
    const dataArray = collection.map(item => {
      return [item[prop], item]
    })
    const maparray = new Map(dataArray)
    return [...maparray.values()]
  }
  const toggleAccordion = item => {
    const i = searchFields.locationFields.findIndex(x => x.locationType === item.locationType && x.locationValue === 'all')
    const newSearchFields = searchFields
    newSearchFields.locationFields[i] = { ...newSearchFields.locationFields[i], show: !newSearchFields.locationFields[i].show }
    if (newSearchFields.locationFields[i].show) {
      newSearchFields.locationFields[i] = { ...newSearchFields.locationFields[i], arrow: 'rotate(0)' }
    } else {
      newSearchFields.locationFields[i] = { ...newSearchFields.locationFields[i], arrow: 'rotate(180)' }
    }
    setSearchFields({ ...newSearchFields })
    // console.log('newSearchFields:::', newSearchFields.locationFields)
  }

  const getFeildValue = item => {
    let feildValues = searchFields.locationFields.filter(x => x.locationType === item && x.locationValue !== 'all')
    feildValues = sortArray(feildValues, 'locationValue', 'asc')

    return feildValues
  }

  const handleSelectedFilters = item => {
    const i = searchFields.locationFields.findIndex(x => x.locationType === item.locationType && x.locationValue === item.locationValue)
    const newSearchFields = searchFields
    newSearchFields.locationFields[i] = { ...newSearchFields.locationFields[i], isChecked: !item.isChecked }
    setSearchFields({ ...newSearchFields })
  }
  const formatLocationFilter = (propCollection) => {
    if (propCollection) {
      getUniqueValues(propCollection, 'city').forEach(item => {
        // when a saved search is loaded, duplicates are coming up in location filter. Hence adding this code
        const i = searchFields.locationFields.findIndex(x => x.locationType === 'City' && x.locationValue === item.city)
        if (i === -1) {
          searchFields.locationFields.push({ 'locationType': 'City', 'locationValue': item.city, 'isChecked': false })
        }
      })
      getUniqueValues(propCollection, 'state').forEach(item => {
        const i = searchFields.locationFields.findIndex(x => x.locationType === 'State' && x.locationValue === item.state)
        if (i === -1) {
          searchFields.locationFields.push({ 'locationType': 'State', 'locationValue': item.state, 'isChecked': false })
        }
      })
      getUniqueValues(propCollection, 'propertyPropertyCounty').forEach(item => {
        const i = searchFields.locationFields.findIndex(x => x.locationType === 'County' && x.locationValue === item.propertyPropertyCounty)
        if (i === -1) {
          searchFields.locationFields.push({ 'locationType': 'County', 'locationValue': item.propertyPropertyCounty, 'isChecked': false })
        }
      })
      getUniqueValues(propCollection, 'zipCode').forEach(item => {
        const i = searchFields.locationFields.findIndex(x => x.locationType === 'Zip Code' && x.locationValue === item.zipCode)
        if (i === -1) {
          searchFields.locationFields.push({ 'locationType': 'Zip Code', 'locationValue': item.zipCode, 'isChecked': false })
        }
      })
      const newSearchFields = searchFields
      setSearchFields({ ...newSearchFields })
    }
  }
  //   if(searchResult.property.length) {
  //     formatLocationFilter(searchResult.property)
  //  }

  return (
    <>
      <div className="overflow-y-auto overflow-x-hidden" >
        {listLocationTypes.map((value, index) => {
          return (
            <>
              <div className="flex flex-col" key={index}>
                <div data-testid={`test-${value.locationType}`} className="flex justify-between py-1 cursor-pointer" onClick={() => toggleAccordion(value)}>
                  <div>
                    <span data-testid={`test-type-header-${value.locationType}`} className="pl-4">
                      {value.locationType}
                    </span>
                  </div>
                  <div>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-auto" transform={value.arrow}>
                      <path fillRule="evenodd" clipRule="evenodd" d="M12 8.30849L20.7197 17.0274C21.0126 17.3203 21.4875 17.3202 21.7804 17.0273C22.0732 16.7344 22.0732 16.2595 21.7803 15.9667L12.9665 7.15366C12.8397 7.02668 12.6889 6.92583 12.5231 6.85708C12.3573 6.78832 12.1795 6.75293 12 6.75293C11.8205 6.75293 11.6427 6.78832 11.4769 6.85708C11.3111 6.92583 11.1605 7.02657 11.0336 7.15355L2.21969 15.9667C1.92679 16.2595 1.92677 16.7344 2.21965 17.0273C2.51252 17.3202 2.9874 17.3203 3.28031 17.0274L12 8.30849Z" fill="black" />
                    </svg>
                  </div>
                  {/* <div className="accordion-icon"></div> */}
                </div>
                {value.show ? <div className="flex pt-4 flex-wrap">
                  {getFeildValue(value.locationType).map(filterVal => {
                    return (
                      <>
                        <div data-testid="test-options">
                          <div data-testid={`test-${value.locationType}-subtype-${filterVal.locationValue}`} onClick={() => handleSelectedFilters(filterVal)}
                            className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-4 py-3 ${filterVal.isChecked ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}
                          // className={`badge rounded-pill px-5 mr-3 mb-4 cursor-pointer ${filterVal.isChecked ? 'text-blue-600 bg-blue-200 border-1 border-base' : ''}`}
                          >
                            {filterVal.locationValue}
                          </div>
                        </div>
                      </>
                    )
                  })}
                </div> : null}
              </div>
            </>
          )
        })}
      </div>
    </>
  )
}

LocationFilters.propTypes = {
  fieldCollection: PropTypes.array
}

export default LocationFilters
